import { useFormContext } from 'react-hook-form';

const Radio = ({
  name,
  value,
  label,
  validationRules = {},
  disabled = false,
  onChange: externalOnChange,
  checked: forcedChecked
}) => {
  const { register, watch, formState: { errors } } = useFormContext();
  const currentValue = watch(name);

  const { onChange, ...rest } = register(name, validationRules);

  const handleChange = (e) => {
    onChange(e);
    if (externalOnChange) externalOnChange(e.target.value);
  };

  const isChecked =
    forcedChecked !== undefined
      ? forcedChecked
      : currentValue === value;

  return (
    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
      <input
        {...rest}
        type="radio"
        value={value}
        className="form-check-input"
        disabled={disabled}
        checked={isChecked}
        onChange={handleChange}
      />
      <span className="form-check-label ms-2">{label}</span>
    </label>
  );
};

export default Radio;